export default __webpack_public_path__ + "static/media/036-traffic-light.b96633f3.png";